import * as Yup from 'yup';


export const AddCompanyValidationSchema = Yup.object().shape({
    companyLogo: Yup.mixed(),
    companyName: Yup.string().required('Company Name is required'),
    companyPhonenumber: Yup.string()
        .required('company Phonenumber is required')
        .matches(/^\d{10}$/, "company Phonenumber must be numeric and exactly 10 digits long"),
    companyAddress: Yup.string().required('Company Address is required'),
    firstName: Yup.string().required('Firstname is required'),
    contactPhonenumber: Yup.string()
        .required('Contact Phonenumber is required')
        .matches(/^\d{10}$/, "Contact Phonenumber must be numeric and exactly 10 digits long"),
    lastName: Yup.string().required('Lastname is required'),
    emailAddress: Yup.string().required('Email Address is required'),
    domainName: Yup.string().required('Domain Name is required').matches(
        /^[a-z.]+$/,
        "Domain name must not contain spaces, special characters, numbers or uppercase letters"
    ).test(
        "no-suffix",
        "Do not include .demandpro.law",
        value => !value?.includes(".demandpro.law")
    ),
    databasePassword: Yup.string(),
    accountantemail: Yup.array()
        .of(
            Yup.string()
                .trim()
                .email('Invalid email format')
                .required('Email is required')
        ),
    usersLimit: Yup.number()
        .required('Users limit is required')
        .typeError('Users limit must be a number'),
    monthlyPrice: Yup.number()
        .required('Monthly price is required')
        .typeError('Monthly price must be a number'),
    demandsPerMonth: Yup.number()
        .required('Demands per month is required')
        .typeError('Demands per month must be a number'),
    costPerAdditionalUser: Yup.number()
        .required('Cost per additional user is required')
        .typeError('Cost per additional user must be a number'),
    costPerAdditionalDemand: Yup.number()
        .required('Cost per additional demand is required')
        .typeError('Cost per additional demand must be a number'),
    chargeAdditionalPlaintiffs: Yup.boolean().required('Charge for additional plaintiffs is required'),
    tier: Yup.string().required('Tier is required'),
    commission: Yup.number()
    .required('Commission is required')
    .typeError('Commission must be a number')
    .min(0, 'Value must be at least 0')
    .max(100, 'Value must be at most 100'),
    homeState: Yup.string()
    .required("Home State is required")
});

export const EditCompanyValidationSchema = AddCompanyValidationSchema.shape({
    rollOverCredits: Yup.number()
          .required('Roll over credits is required')
          .typeError('Roll over credits must be a number'),
    remainingDemand: Yup.number()
          .required('Remaining demand is required')
          .typeError('Remaining demand must be a number'),
});